import { render, staticRenderFns } from "./payslip-report.vue?vue&type=template&id=0a428208&scoped=true&"
import script from "./payslip-report.vue?vue&type=script&lang=js&"
export * from "./payslip-report.vue?vue&type=script&lang=js&"
import style0 from "./payslip-report.vue?vue&type=style&index=0&id=0a428208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a428208",
  null
  
)

export default component.exports